<script>
	import { getContext } from "svelte";
	import Sparkline from "../components/Sparkline.svelte";
	import LinkStatsHistory from "./linkStatsHistory";
	import { ChevronDownIcon, ChevronUpIcon } from "svelte-feather-icons";

	export let link;

	const flight = getContext("flight");
	let store = flight.getHandler(LinkStatsHistory);

	$: data = $store && $store[link.id] && $store[link.id].history

	let showSparks;
	function toggleSparks() {
		showSparks = !showSparks;
	}
</script>


<div class="expandLine">
	<div class="expandLink" on:click={toggleSparks}>
		details
		<div class="arrow">
			{#if showSparks}
				<ChevronUpIcon />
			{:else}
				<ChevronDownIcon />
			{/if}
		</div>
	</div>
</div>
{#if !showSparks}
<Sparkline
	{data}
	title="RSSI"
	property="rssi"
	min={-130}
	max={-20}
	digits={2}
/>
{:else}
	<Sparkline
		{data}
		title="Primary RSSI"
		property="primary"
		min={-130}
		max={-20}
		digits={2}
	/>
	<Sparkline
		{data}
		title="Secondary RSSI"
		property="secondary"
		min={-130}
		max={-20}
		digits={2}
	/>
	<Sparkline {data} title="Altitude" property="altitude" units="meters MSL" />
	<Sparkline {data} title="TX Bytes" property="txBytes" units="bytes total" />
	<Sparkline {data} title="RX Bytes" property="rxBytes" units="bytes total" />
	<Sparkline {data} title="Slant" property="slant" units="meters"/>
	<Sparkline {data} title="GPS Satellites" property="sats" />
{/if}

<style>
	.arrow {
		height: 18px;
		width: 18px;
		margin: 0;
		padding: 0;
		display: flex;
	}
	.expandLine {
		font-size: 8pt;
		margin-top: 4px;
	}

	.expandLine div {
		display: flex;
		height: 100%;
		justify-content: right;
		align-items: center;
		cursor: pointer;
		user-select: none;
		color: #1eaedb;
	}
</style>
